import { Fragment, useState } from 'react';
import { useRouter } from 'next/router';

import { Icon } from '@playbooks/ui/components/icon';

import { SearchModal } from 'components/search/search-modal';
import { useKeyDown } from 'hooks';

const BlogSearch = () => {
	const [open, setOpen] = useState(false);
	const router = useRouter();

	// Hooks
	useKeyDown(onKeyDown, [router.asPath]);

	// Functions
	function onKeyDown(e) {
		if (e.keyCode === 75 && e.metaKey) onOpen();
		if (e.keyCode === 27) setOpen(false);
	}

	// Methods
	const onOpen = () => {
		setOpen(true);
	};

	// Render
	return (
		<Fragment>
			<button
				type='button'
				aria-haspopup='dialog'
				aria-expanded={open}
				onClick={onOpen}
				className='flex-start h-9 w-full gap-2 rounded-media border border-border-strong bg-surface-control px-3 text-left text-sm font-normal text-foreground outline-none transition-colors hover:bg-surface-hover focus-visible:border-focus focus-visible:ring-3 focus-visible:ring-focus/50'>
				<Icon type='far' icon='magnifying-glass' aria-hidden className='shrink-0 text-xs text-foreground-body' />
				<span className='min-w-0 grow truncate'>Search blog...</span>
				<kbd className='shrink-0 rounded-control bg-surface px-1.5 py-1 text-xs leading-none text-foreground-body'>
					⌘K
				</kbd>
			</button>

			<SearchModal tableName='articles' placeholder='Search blog...' open={open} setOpen={setOpen} />
		</Fragment>
	);
};
export { BlogSearch };
